import { useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import { submitFeedback } from "../services/api";

export default function FeedbackButtons({ messageId }) {
  const [selected, setSelected] = useState(null);
  const [showNotes, setShowNotes] = useState(false);
  const [notes, setNotes] = useState("");

  const handleFeedback = async (feedback) => {
    if (selected) return;
    setSelected(feedback);
    if (feedback === "negative") {
      setShowNotes(true);
    } else {
      await submitFeedback(messageId, feedback);
    }
  };

  const handleSubmitNotes = async () => {
    await submitFeedback(messageId, "negative", notes || null);
    setShowNotes(false);
  };

  return (
    <Box sx={{ mt: 0.5, px: 0.5 }}>
      <Box sx={{ display: "flex", gap: 0.5 }}>
        <IconButton
          size="small"
          onClick={() => handleFeedback("positive")}
          disabled={!!selected}
          sx={{ color: selected === "positive" ? "primary.main" : "text.disabled" }}
        >
          {selected === "positive" ? <ThumbUpIcon fontSize="small" /> : <ThumbUpOutlinedIcon fontSize="small" />}
        </IconButton>
        <IconButton
          size="small"
          onClick={() => handleFeedback("negative")}
          disabled={!!selected && !showNotes}
          sx={{ color: selected === "negative" ? "primary.main" : "text.disabled" }}
        >
          {selected === "negative" ? <ThumbDownIcon fontSize="small" /> : <ThumbDownOutlinedIcon fontSize="small" />}
        </IconButton>
      </Box>
      {showNotes && (
        <Box sx={{ display: "flex", gap: 1, mt: 1, maxWidth: 360 }}>
          <TextField
            size="small"
            placeholder="What was wrong? (optional)"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            fullWidth
            sx={{ "& .MuiOutlinedInput-root": { fontSize: 13 } }}
          />
          <Button size="small" variant="contained" onClick={handleSubmitNotes}>
            Send
          </Button>
        </Box>
      )}
    </Box>
  );
}
